import app from "/src/app/app.module";

/**
 * HTML5 Drag-and-Drop helpers as AngularJS attribute directives
 */
app.directive('ngDragstart', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            // Ensure element is draggable
            if (!element.attr('draggable')) {
                element.attr('draggable', true);
            }
            element.on('dragstart', function (event) {
                var ev = event.originalEvent || event;
                scope.$applyAsync(function () {
                    scope.$eval(attrs.ngDragstart, { $event: ev });
                });
            });
        }
    };
});

app.directive('ngDragend', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('dragend', function (event) {
                var ev = event.originalEvent || event;
                scope.$applyAsync(function () {
                    scope.$eval(attrs.ngDragend, { $event: ev });
                });
            });
        }
    };
});

app.directive('ngDragover', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('dragover', function (event) {
                var ev = event.originalEvent || event;
                ev.preventDefault();
                if (ev.dataTransfer) {
                    ev.dataTransfer.dropEffect = 'move';
                }
                if (attrs.ngDragover) {
                    scope.$applyAsync(function () {
                        scope.$eval(attrs.ngDragover, { $event: ev, $element: element[0] });
                    });
                }
            });
        }
    };
});

app.directive('ngDragleave', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('dragleave', function (event) {
                var ev = event.originalEvent || event;
                if (attrs.ngDragleave) {
                    scope.$applyAsync(function () {
                        scope.$eval(attrs.ngDragleave, { $event: ev });
                    });
                }
            });
        }
    };
});

app.directive('ngDrop', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            // Enable drop by handling dragover
            element.on('dragover', function (event) {
                var ev = event.originalEvent || event;
                ev.preventDefault();
                ev.stopPropagation();
                if (ev.dataTransfer) {
                    ev.dataTransfer.dropEffect = 'copy';
                }
                return false;
            });
            
            element.on('dragenter', function (event) {
                var ev = event.originalEvent || event;
                ev.preventDefault();
                return false;
            });
            
            element.on('drop', function (event) {
                var ev = event.originalEvent || event;
                ev.preventDefault();
                ev.stopPropagation();
                console.log('Drop event on element:', element, 'event:', ev);
                scope.$applyAsync(function () {
                    scope.$eval(attrs.ngDrop, { $event: ev, $element: element[0] });
                });
                return false;
            });
        }
    };
});

/**
 * Form Builder Controller
 * Allows users to visually create form schemas using drag-and-drop
 * Generates autofields-compatible JSON schema output
 */
app.controller('form_builder', function ($scope, $timeout, toastr, vxUtils) {
    var vm = this;
    var fieldIdCounter = 0;
    var formIdCounter = 0;

    /**
     * Initialize controller
     */
    vm.fieldTypes = [
        { value: 'text', label: 'Text Input', icon: 'fa-font', description: 'Single-line text input' },
        { value: 'email', label: 'Email', icon: 'fa-envelope', description: 'Email input field' },
        { value: 'number', label: 'Number', icon: 'fa-calculator', description: 'Numeric input' },
        { value: 'password', label: 'Password', icon: 'fa-lock', description: 'Password input field' },
        { value: 'textarea', label: 'Textarea', icon: 'fa-file-text', description: 'Multi-line text input' },
        { value: 'checkbox', label: 'Checkbox', icon: 'fa-check-square', description: 'Boolean checkbox' },
        { value: 'date', label: 'Date', icon: 'fa-calendar', description: 'Date picker field' },
        { value: 'select', label: 'Select', icon: 'fa-list', description: 'Dropdown select field' }
    ];
    /**
     * Create a new empty form
     */
    vm.createNewForm = function () {
        return {
            id: 'form_' + (++formIdCounter),
            name: 'New Form',
            createdDate: new Date(),
            schema: []
        };
    };

    vm.savedForms = [];
    vm.currentForm = vm.createNewForm();
    vm.canvas = [];
    vm.selectedField = null;
    vm.generatedSchema = [];
    vm.draggedField = null;
    vm.draggedFieldType = null;
    vm.dropTargetIndex = null;
    vm.schemaExpanded = false;

    /**
     * Preview data and options for the form preview
     */
    vm.previewData = {};
    vm.previewOptions = {
        validation: { enabled: true },
        layout: { type: 'vertical' }
    };


    /**
     * Create a new field object
     */
    vm.createField = function (fieldType, isInRow) {
        var type = typeof fieldType === 'string' ? fieldType : fieldType.value;
        var field = {
            id: 'field_' + (++fieldIdCounter),
            property: 'property_' + fieldIdCounter,
            type: type,
            label: type.charAt(0).toUpperCase() + type.slice(1),
            placeholder: '',
            help: '',
            columns: 12,
            attr: {
                required: false,
                minlength: null,
                maxlength: null
            },
            msgs: {},
            options: []
        };
        
        // Add default options array for select fields
        if (type === 'select') {
            field.options = [
                { value: 'option1', label: 'Option 1' },
                { value: 'option2', label: 'Option 2' }
            ];
        }
        
        // Add default value for checkbox
        if (type === 'checkbox') {
            field.defaultValue = false;
        }
        
        return field;
    };

    /**
     * Create a new multi-column row
     */
    vm.createRow = function () {
        return {
            id: 'row_' + (++fieldIdCounter),
            type: 'multiple',
            columns: 2,
            fields: []
        };
    };

    /**
     * Add a new form
     */
    vm.newForm = function () {
        vm.currentForm = vm.createNewForm();
        vm.canvas = [];
        vm.selectedField = null;
        vm.generateSchema();
    };

    /**
     * Save the current form to the savedForms list
     */
    vm.saveForm = function () {
        if (!vm.currentForm.name || vm.currentForm.name.trim() === '') {
            toastr.error(vxUtils.loc('REQUIRED'), 'Please enter a form name');
            return;
        }

        var existingForm = vm.savedForms.find(function (f) { return f.id === vm.currentForm.id; });

        if (existingForm) {
            existingForm.name = vm.currentForm.name;
            existingForm.schema = angular.copy(vm.canvas);
        } else {
            vm.currentForm.schema = angular.copy(vm.canvas);
            vm.savedForms.push(angular.copy(vm.currentForm));
        }

        $scope.$evalAsync(function() {
            toastr.success(vxUtils.loc('SUCCES'), 'Form saved successfully');
        });
    };

    /**
     * Select and load a form from savedForms
     */
    vm.selectForm = function (form) {
        vm.currentForm = angular.copy(form);
        vm.canvas = angular.copy(form.schema);
        vm.selectedField = null;
        vm.generateSchema();
    };

    /**
     * Delete a form
     */
    vm.deleteForm = function (formId, $event) {
        $event.stopPropagation();

        var index = vm.savedForms.findIndex(function (f) { return f.id === formId; });
        if (index !== -1) {
            vm.savedForms.splice(index, 1);

            if (vm.currentForm.id === formId) {
                vm.newForm();
            }

            $scope.$evalAsync(function() {
                toastr.info('Form deleted');
            });
        }
    };

    /**
     * Add a field to the canvas
     */
    vm.addField = function (fieldType) {
        var newField = vm.createField(fieldType);
        vm.canvas.push(newField);
        vm.selectedField = newField;
        vm.generateSchema();
    };

    /**
     * Add a multi-column row to the canvas
     */
    vm.addRow = function () {
        var newRow = vm.createRow();
        vm.canvas.push(newRow);
        vm.selectedField = newRow;
        vm.generateSchema();
    };

    /**
     * Add a field to an existing row
     */
    vm.addFieldToRow = function (rowId) {
        var row = vm.canvas.find(function (item) { return item.id === rowId; });
        if (row && row.type === 'multiple') {
            var newField = vm.createField('text', true);
            row.fields.push(newField);
            vm.selectedField = newField;
            vm.generateSchema();
        }
    };

    /**
     * Remove a field from the canvas
     */
    vm.removeField = function (fieldId, $event) {
        if ($event) {
            $event.stopPropagation();
        }

        var index = vm.canvas.findIndex(function (f) { return f.id === fieldId; });
        if (index !== -1) {
            vm.canvas.splice(index, 1);
            vm.selectedField = null;
            vm.generateSchema();
        }
    };

    /**
     * Remove a field from a row
     */
    vm.removeFieldFromRow = function (rowId, fieldId, $event) {
        if ($event) {
            $event.stopPropagation();
        }

        var row = vm.canvas.find(function (item) { return item.id === rowId; });
        if (row) {
            var fieldIndex = row.fields.findIndex(function (f) { return f.id === fieldId; });
            if (fieldIndex !== -1) {
                row.fields.splice(fieldIndex, 1);
                vm.selectedField = null;
                vm.generateSchema();
            }
        }
    };

    /**
     * Select a field for editing
     */
    vm.selectField = function (field, $event) {
        if ($event) {
            $event.stopPropagation();
        }
        vm.selectedField = field;
    };

    /**
     * Check if a field type is a text-based field
     */
    vm.isTextField = function (type) {
        return ['text', 'email', 'number', 'password'].indexOf(type) !== -1;
    };

    /**
     * Add an option to select field
     */
    vm.addOption = function () {
        if (!vm.selectedField || !vm.selectedField.options) {
            vm.selectedField.options = [];
        }
        var optionNum = vm.selectedField.options.length + 1;
        vm.selectedField.options.push({
            value: 'option' + optionNum,
            label: 'Option ' + optionNum
        });
        vm.generateSchema();
    };

    /**
     * Remove an option from select field
     */
    vm.removeOption = function (index) {
        if (vm.selectedField && vm.selectedField.options) {
            vm.selectedField.options.splice(index, 1);
            vm.generateSchema();
        }
    };

    /**
     * Handle drag start from field palette (new field)
     */
    vm.onDragStartFieldType = function ($event, fieldType) {
        $event.dataTransfer.effectAllowed = 'copy';
        $event.dataTransfer.setData('text/plain', 'newfield:' + fieldType.value);
        vm.draggedFieldType = fieldType;
        console.log('Drag started: new field type', fieldType.value);
    };

    /**
     * Handle drag start from canvas field (existing field - reorder)
     */
    vm.onDragStartField = function ($event, field, index) {
        $event.dataTransfer.effectAllowed = 'move';
        $event.dataTransfer.setData('text/plain', field.id);
        vm.draggedField = { field: field, index: index, fromIndex: index };
        console.log('Drag started:', field.id, 'at index', index);
    };

    /**
     * Handle drag end
     */
    vm.onDragEnd = function ($event) {
        console.log('Drag ended');
        vm.draggedField = null;
        vm.draggedFieldType = null;
        vm.dropTargetIndex = null;
    };

    /**
     * Handle drag over canvas and show drop target (fallback)
     */
    vm.onDragOver = function ($event, $element) {
        if ($event) {
            $event.preventDefault();
            if ($event.dataTransfer) {
                $event.dataTransfer.dropEffect = vm.draggedFieldType ? 'copy' : 'move';
            }
        }

        // Fallback: if hovering empty space, show as dropping at end
        if (vm.draggedField || vm.draggedFieldType) {
            vm.dropTargetIndex = vm.canvas.length;
            $scope.$applyAsync();
        }
        return false;
    };

    /**
     * Canvas-level dragover to allow drops from palette
     */
    vm.onCanvasDragOver = function ($event) {
        if ($event) {
            $event.preventDefault();
            if ($event.dataTransfer) {
                $event.dataTransfer.dropEffect = vm.draggedFieldType ? 'copy' : 'move';
            }
        }
        // If no items exist, still show drop index 0
        if ((vm.draggedField || vm.draggedFieldType) && vm.canvas.length === 0) {
            vm.dropTargetIndex = 0;
            $scope.$applyAsync();
        }
        return false;
    };

    /**
     * Handle drag over a specific item to compute before/after highlight
     */
    vm.onItemDragOver = function ($event, $element, index) {
        if ($event) {
            $event.preventDefault();
            if ($event.dataTransfer) {
                $event.dataTransfer.dropEffect = vm.draggedFieldType ? 'copy' : 'move';
            }
        }
        if (!(vm.draggedField || vm.draggedFieldType) || !$element) { return false; }

        var rect = $element.getBoundingClientRect();
        var mid = rect.top + rect.height / 2;
        var y = $event.clientY;
        var targetIndex = y < mid ? index : index + 1;

        if (vm.dropTargetIndex !== targetIndex) {
            vm.dropTargetIndex = targetIndex;
            $scope.$applyAsync();
        }
        return false;
    };

    /**
     * Handle drag leave
     */
    vm.onDragLeave = function ($event) {
        vm.dropTargetIndex = null;
    };

    /**
     * Handle drag over row interior (to add fields to row)
     */
    vm.onRowDragOver = function ($event) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            if ($event.dataTransfer) {
                $event.dataTransfer.dropEffect = 'copy';
            }
        }
        return false;
    };

    /**
     * Handle drop into row (add field to row)
     */
    vm.onDropFieldIntoRow = function ($event, row) {
        $event.preventDefault();
        $event.stopPropagation();
        
        console.log('Drop into row:', row);
        
        // Only allow dropping new fields from palette into rows
        if (vm.draggedFieldType) {
            var newField = vm.createField(vm.draggedFieldType, true);
            row.fields.push(newField);
            vm.selectedField = newField;
            console.log('Field added to row:', newField);
            vm.draggedFieldType = null;
            vm.generateSchema();
            $scope.$applyAsync();
            return false;
        }
        
        // Ignore reordering existing canvas fields into rows
        if (vm.draggedField) {
            console.log('Cannot move existing canvas field into row');
            vm.draggedField = null;
        }
        
        return false;
    };

    /**
     * Handle drop on canvas at specific position
     */
    vm.onDropField = function ($event, $element, itemIndex) {
        $event.preventDefault();
        $event.stopPropagation();

        // Handle new field from palette
        if (vm.draggedFieldType) {
            var targetIndex = (typeof itemIndex === 'number') ? itemIndex : vm.canvas.length;
            var newField = vm.createField(vm.draggedFieldType);
            vm.canvas.splice(targetIndex, 0, newField);
            vm.selectedField = newField;
            console.log('New field added at index', targetIndex);
            vm.draggedFieldType = null;
            vm.dropTargetIndex = null;
            vm.generateSchema();
            $scope.$applyAsync();
            return false;
        }

        // Handle reordering existing field
        if (!vm.draggedField) { return false; }

        var fromIndex = vm.draggedField.fromIndex;
        var draggedItem = vm.canvas[fromIndex];
        if (!draggedItem) { return false; }

        // Use computed dropTargetIndex if available; otherwise use itemIndex or default to end
        var targetIndex = (typeof vm.dropTargetIndex === 'number') ? vm.dropTargetIndex : (typeof itemIndex === 'number' ? itemIndex : vm.canvas.length);

        // Remove from old position first
        vm.canvas.splice(fromIndex, 1);
        // Adjust target index if moving downwards
        if (targetIndex > fromIndex) { targetIndex--; }

        vm.canvas.splice(targetIndex, 0, draggedItem);
        console.log('Field reordered from', fromIndex, 'to', targetIndex);

        vm.draggedField = null;
        vm.dropTargetIndex = null;
        vm.generateSchema();
        $scope.$applyAsync();
        return false;
    };

    /**
     * Generate the autofields-compatible schema from the canvas
     */
    vm.generateSchema = function () {
        vm.generatedSchema = [];

        angular.forEach(vm.canvas, function (item) {
            if (item.type === 'multiple') {
                // Handle multi-column row
                var rowSchema = {
                    type: 'multiple',
                    columns: item.columns,
                    fields: []
                };

                angular.forEach(item.fields, function (field) {
                    var fieldSchema = vm.fieldToSchema(field);
                    // Inject select options onto scope
                    if (field.type === 'select' && field.options && field.options.length > 0) {
                        vm['generatedSchemaOptions_' + field.id] = field.options;
                    }
                    rowSchema.fields.push(fieldSchema);
                });

                vm.generatedSchema.push(rowSchema);
            } else {
                // Handle regular field
                var fieldSchema = vm.fieldToSchema(item);
                // Inject select options onto scope
                if (item.type === 'select' && item.options && item.options.length > 0) {
                    vm['generatedSchemaOptions_' + item.id] = item.options;
                }
                vm.generatedSchema.push(fieldSchema);
            }
        });
    };

    /**
     * Convert a field object to schema format
     */
    vm.fieldToSchema = function (field) {
        var schema = {
            property: field.property,
            type: field.type,
            label: field.label
        };

        if (field.placeholder) {
            schema.placeholder = field.placeholder;
        }

        if (field.help) {
            schema.help = field.help;
        }

        if (field.columns && field.columns !== 12) {
            schema.columns = field.columns;
        }

        // Add options for select fields
        // Autofields expects 'list' property with ng-options format: "item.label for item in items"
        if (field.type === 'select' && field.options && field.options.length > 0) {
            // Store options on scope under a unique name
            var optionsVarName = 'formBuilderOptions_' + field.id;
            // Return the ng-options expression for autofields
            schema.list = 'option.label for option in vm.generatedSchemaOptions_' + field.id;
            // Store the actual options in a temporary location
            schema._options = field.options;
        }

        // Add default value for checkbox
        if (field.type === 'checkbox' && field.defaultValue) {
            schema.defaultValue = field.defaultValue;
        }

        // Build attr object with validation rules
        var attr = {};

        if (field.attr.required) {
            attr.required = 'required';
        }

        if (field.attr.minlength) {
            attr['ng-minlength'] = field.attr.minlength;
        }

        if (field.attr.maxlength) {
            attr['ng-maxlength'] = field.attr.maxlength;
        }

        if (Object.keys(attr).length > 0) {
            schema.attr = attr;
        }

        // Build msgs object for validation messages
        var msgs = {};

        if (field.attr.required) {
            msgs.required = 'This field is required';
        }

        if (field.attr.minlength) {
            msgs.minlength = 'Minimum ' + field.attr.minlength + ' characters required';
        }

        if (field.attr.maxlength) {
            msgs.maxlength = 'Maximum ' + field.attr.maxlength + ' characters allowed';
        }

        if (Object.keys(msgs).length > 0) {
            schema.msgs = msgs;
        }

        return schema;
    };

    /**
     * Export the generated schema to console
     */
    vm.exportToConsole = function () {
        vm.generateSchema();

        var schemaOutput = {
            formName: vm.currentForm.name,
            schema: vm.generatedSchema,
            generatedAt: new Date().toISOString()
        };

        console.log('Generated Form Schema:', schemaOutput);
        console.log(JSON.stringify(vm.generatedSchema, null, 2));

        $scope.$evalAsync(function() {
            toastr.success(vxUtils.loc('SUCCES'), 'Schema exported to console');
        });
    };

    /**
     * Copy schema to clipboard
     */
    vm.copySchemaToClipboard = function () {
        vm.generateSchema();

        var schemaText = JSON.stringify(vm.generatedSchema, null, 2);

        var textArea = document.createElement('textarea');
        textArea.value = schemaText;
        document.body.appendChild(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
            $scope.$evalAsync(function() {
                toastr.success(vxUtils.loc('SUCCES'), 'Schema copied to clipboard');
            });
        } catch (e) {
            $scope.$evalAsync(function() {
                toastr.error('Failed to copy to clipboard', 'Error');
            });
        }

        document.body.removeChild(textArea);
    };

    /**
     * Watch for changes in canvas to update schema in real-time
     */
    $scope.$watch(function () {
        return JSON.stringify(vm.canvas);
    }, function () {
        vm.generateSchema();
    });

    /**
     * Watch for changes in selectedField to update schema
     */
    $scope.$watch(function () {
        return vm.selectedField ? JSON.stringify(vm.selectedField) : null;
    }, function () {
        vm.generateSchema();
    }, true);
});